// extracted by mini-css-extract-plugin
module.exports = {"logo":"HomePage_logo__3J66i","h_px_100":"HomePage_h_px_100__1EIIZ","versionDisplayContainer":"HomePage_versionDisplayContainer__3rw7v"};